<template>
  <div id="content-wrapper" class="content-wrapper">
    <div class="page page-orderdetail">
      <div class="row">
        <div
          class="columns medium-11 large-9 medium-centered end confirmation-wrapper"
        >
          <div class="clearfix">
            <div class="columns">
              <div class="ppto-payment-error form-error error"></div>

              <header class="clearfix page-title">
                <img
                  src="../../assets/images/wineaccess-logo-black.svg"
                  class="print-logo"
                  alt="Wine Access Logo"
                  data-not-lazy
                />
                <slot name="greeting">
                  <h1 id="order-greeting">
                    Thank you for gifting
                    <br class="show-for-small-only" />{{
                      order.term.membership_type.name
                    }}!
                  </h1>
                </slot>

                <div id="order-meta" class="order-meta">
                  <slot name="subheader">
                    <p
                      v-if="
                        $moment(order.send_date, 'YYYY-MM-DD').isBefore(
                          $moment(),
                        )
                      "
                    >
                      We've notified the lucky recipient.
                    </p>
                    <p v-else>
                      We’ll notify the lucky recipient on
                      {{
                        $moment(order.send_date, 'YYYY-MM-DD').format(
                          'dddd, MMMM Do',
                        )
                      }}.
                    </p>
                  </slot>
                  <p>
                    You will receive a confirmation email shortly at
                    <span id="user-email">{{ order.gifter_email }}</span>
                  </p>
                </div>
              </header>
            </div>
          </div>

          <div class="clearfix section-header">
            <div class="columns medium-7">
              <h2>Shipping &amp; Billing Details</h2>
            </div>
            <div class="columns medium-5 show-for-medium-up text-right">
              <button
                v-if="!inMobileApp"
                class="button button-solid max print-page hide-for-print"
                @click="print()"
              >
                Print Receipt
              </button>
            </div>
          </div>

          <div class="clearfix shipping">
            <div class="columns small-6 medium-3 print-3 payment-method">
              <div class="title">Payment:</div>

              <template
                v-if="
                  order.payment_method &&
                  order.payment_method.card_type === 'PayPal'
                "
              >
                PayPal ({{ order.payment_method.email }})
              </template>
              <template
                v-if="
                  order.payment_method &&
                  order.payment_method.card_type === 'ApplePay'
                "
              >
                Apple Pay - {{ order.payment_method.payment_instrument_name }}
              </template>

              <template v-else-if="order.payment_method">
                <template v-if="order.payment_method.cardholder_name"
                  >{{ order.payment_method.cardholder_name }}<br /></template
                ><span class="card-ending"
                  >{{ order.payment_method.card_type }} ending in
                  {{ order.payment_method.last_4 }}</span
                >
                <br />Exp: {{ order.payment_method.expiration_date }}
              </template>

              <template v-else> No charges. </template>
            </div>
            <div class="columns small-6 medium-3 print-3 payment-method">
              <div class="title">Order Number:</div>
              {{ order.gift_code }}
            </div>
            <div class="columns small-6 medium-3 print-3 payment-method">
              <div class="title">Giftee Email:</div>
              {{ order.email }}
            </div>
            <div class="columns small-6 medium-3 print-3 shipping-address">
              <div class="title">Giftee Shipping:</div>

              {{ order.first_name }} {{ order.last_name }} <br />{{
                order.line_1
              }}
              <template v-if="order.line_2">
                <br />{{ order.line_2 }}
              </template>

              <template v-if="order.company">
                <br />{{ order.company }}
              </template>

              <br />{{ order.city }}, {{ order.state }}
              {{ order.postcode }}
            </div>
          </div>

          <div class="clearfix delivery">
            <div class="clearfix delivery-date-status">
              <div
                v-if="order.gift_message"
                class="columns small-text-center medium-text-left"
              >
                Gift Note: <strong> {{ order.gift_message }} </strong>
              </div>
            </div>

            <div class="clearfix table-header">
              <div class="columns small-6 print-6">Gift Items</div>
              <div class="columns small-2 print-2 text-right">
                Price Per Shipment
              </div>
              <div class="columns small-2 print-2 text-right">Total</div>
            </div>

            <div class="table-rows">
              <div class="clearfix table-row">
                <div class="columns small-6 print-6">
                  {{ order.term.membership_type.name }}
                  <br />
                  <span v-if="order.term.membership_type.plans.length > 1"
                    >{{ order.term.plan.name }},</span
                  >
                  {{ order.term.num_of_shipments }} shipment{{
                    order.term.num_of_shipments > 1 ? 's' : ''
                  }},
                  {{ order.term.membership_type.bottles_per_delivery }}
                  bottle{{
                    order.term.membership_type.bottles_per_delivery > 1
                      ? 's'
                      : ''
                  }}
                  per shipment.
                  {{ order.term.membership_type.gift_delivery_frequency }}.
                </div>
                <div class="columns small-2 print-2 text-right">
                  <Price :amt="Number(order.term.plan.shipment_price)" />
                </div>
                <div class="columns small-2 print-2 text-right">
                  <Price :amt="Number(order.term.base_price)" />
                </div>
              </div>
            </div>

            <div class="row hide-for-print">
              <div class="columns medium-8 large-7 end"></div>
            </div>

            <div class="clearfix seller">
              <div class="columns">
                <div class="rule"></div>
              </div>
            </div>

            <!-- Order Total -->
            <div class="clearfix">
              <div class="columns">
                <div class="totals">
                  <div class="row">
                    <div class="columns small-7 print-7">Gift Total</div>
                    <div
                      class="columns small-5 print-5 text-right order-subtotal-amount"
                    >
                      <Price :amt="Number(order.subtotal)" />
                    </div>
                  </div>
                  <div
                    v-if="order.discount_amount > 0"
                    class="row color-discount"
                  >
                    <div class="columns small-7 print-7">
                      {{ order.discount_name }}
                    </div>
                    <div
                      class="columns small-5 print-5 text-right order-subtotal-amount"
                    >
                      -<Price :amt="Number(order.discount_amount)" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="columns small-7 print-7">Estimated Taxes</div>
                    <div
                      class="columns small-5 text-right print-5 order-taxes-amount"
                    >
                      <Price :amt="Number(order.taxes)" />
                    </div>
                  </div>
                  <div v-if="order.surcharge > 0" class="row">
                    <div class="columns small-7 print-7">Service Fee</div>
                    <div
                      class="columns small-5 text-right print-5 order-taxes-amount"
                    >
                      <Price :amt="Number(order.single_surcharge)" />
                      per shipment
                    </div>
                  </div>

                  <div class="row">
                    <div class="columns small-7 print-7">Shipping</div>
                    <div
                      v-if="order.expected_shipping_cost > 0"
                      class="columns small-5 text-right print-5 expected-shipping"
                    >
                      <Price :amt="Number(order.expected_shipping_cost)" />
                    </div>
                    <div v-else class="columns small-5 text-right print-5">
                      Included
                    </div>
                  </div>

                  <div class="row total">
                    <div class="columns small-7 print-7 order-total-text">
                      Order Total
                    </div>
                    <div
                      class="columns small-5 print-5 text-right order-total-amount"
                    >
                      <Price :amt="Number(order.grand_total)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Order Total -->

            <div class="row">
              <div class="columns charge-detail">
                <template v-if="order.grand_total > 0">
                  <p>
                    Your credit card has been charged
                    <Price :amt="Number(order.grand_total)" /> on
                    {{ getFormattedDate(order.date_placed) }}. The charge will
                    appear as "Kachina LLC - WineAccess" on your credit card
                    statement.
                  </p>
                </template>
              </div>

              <div class="thankyou-customerservice transparent">
                <div class="copy">
                  <p>
                    If you’d like to make changes at any time, or have
                    questions, please don’t hesitate to contact our Napa-based
                    member services team at
                    <CustomerServiceEmailLink />
                    or
                    <CustomerServicePhoneLink :with-hours-long="true" />.
                  </p>
                </div>
              </div>
              <div class="clearfix">
                <div
                  class="columns medium-6 medium-centered hide-for-print text-center"
                >
                  <nuxt-link
                    to="/"
                    class="button button-solid max continue-shopping"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                    >Continue Shopping</nuxt-link
                  >
                </div>
              </div>
            </div>

            <div class="row contact-weather">
              <div class="columns contact hide-for-medium-up">
                <a :href="`tel:${metadata.customerService.number}`"
                  >Have Questions? Contact Us
                  <span class="nowrap">{{
                    metadata.customerService.numberDisplay
                  }}</span></a
                >
              </div>
              <div class="columns">
                <div class="rule"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Price from '#common/components/Price.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'GiftingPurchaseThankYou',
  components: { Price },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['inMobileApp']),
  },
  beforeMount() {
    this.layout.showHeader = true
    this.layout.showFooter = true
  },
  created() {
    this.layout = useLayout()
    this.metadata = useMetadata()
  },
  methods: {
    getFormattedDate(date) {
      return this.$moment(date).format('dddd, MMM DD')
    },
    print(e) {
      window.print()
    },
  },
}
</script>
